module.exports = __webpack_public_path__ + "static/media/10.1a85d5b8.jpg";